import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingCost2 = props => (
    <section id="outsourcing-cost-section2" className="blue-bg my pt-5">
        <Container>
            <p className='mb-5'><Trans i18nKey="services:outsourcingCost:section-1.txt" components={{ br: <br /> }} /></p>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingCost:section-2.title')}</h2>
            <p className='mb-5'>
                <Trans i18nKey="services:outsourcingCost:section-2.text"
                    components={{
                        br: <br />,
                        outsourcingPilar: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_pilar.path')} className="link" />
                    }}
                />
            </p>
            {/* Sub-item 1 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingCost:section-2.1.title')}</h3>
                </div>
                <p><Trans i18nKey="services:outsourcingCost:section-2.1.text" components={{ br: <br /> }} /></p>
            </div>
            {/* Sub-item 2 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingCost:section-2.2.title')}</h3>
                </div>
                <p><Trans i18nKey="services:outsourcingCost:section-2.2.text" components={{ br: <br /> }} /></p>
            </div>
            {/* Sub-item 3 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingCost:section-2.3.title')}</h3>
                </div>
                <p><Trans i18nKey="services:outsourcingCost:section-2.3.text" components={{ br: <br /> }} /></p>
            </div>
            {/* Sub-item 4 — with subtitles */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingCost:section-2.4.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingCost:section-2.4.txt')}</p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingCost:section-2.4.subtitle.1.title')}</h4>
                <p>{props.t('services:outsourcingCost:section-2.4.subtitle.1.text')}</p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingCost:section-2.4.subtitle.2.title')}</h4>
                <p>{props.t('services:outsourcingCost:section-2.4.subtitle.2.text')}</p>
                <h4 className='h6 fw-600 light-orange'>{props.t('services:outsourcingCost:section-2.4.subtitle.3.title')}</h4>
                <p className='m-0'>{props.t('services:outsourcingCost:section-2.4.subtitle.3.text')}</p>
            </div>
        </Container>
    </section>
);

export default OutsourcingCost2;
